/*
    *工具 公用方法 全局方法
    *
    *
    *
*/
Array.prototype.in_array = function (element) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] == element) {
            return true;
        }
    }
    return false;
}
import { BASE_CONFIG } from '@/config/config'
import download from "@/utils/download";
export default {
    install(Vue, options) {
        //获取全局公共配置
        Vue.prototype.$getConfig = function () {
            return BASE_CONFIG
        }
        //清除全局缓存
        Vue.prototype.$removeRootScope = function (key) {
            if (sessionStorage.getItem(key)) {
                sessionStorage.removeItem(key);
            }
        }
        //新增缓存字段
        Vue.prototype.$setRootScope = function (key, value) {
            if (sessionStorage.getItem(key)) {
                sessionStorage.removeItem(key);
            }
            sessionStorage.setItem(key, value)
            //sessionStorage.setItem(key, value);
        }
        //获取缓存
        Vue.prototype.$getRootScope = function (key) {
            let res = sessionStorage.getItem(key)
            return res
        }

        //去商城
        Vue.prototype.$goMallPath = function (path) {
            window.location = `${this.$getConfig().MALL_ROOT_URL}/#/${path}`
        }

        //获取浏览器传值的参数
        Vue.prototype.$getQueryString = function (name) {

            let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            let getUrl = window.location.href

            if (getUrl.indexOf("?") != -1) {
                var url = getUrl.substr(getUrl.indexOf("?"))

                let r = url.substr(1).match(reg);

                if (r != null) return decodeURIComponent(r[2]);
                return null;

            }
        }
        /**
         * 全局配置平台相关信息 客服、微信、邮箱
         */
        Vue.prototype.$platformContact = function () {
            return {
                hotLine: "400-0609-008",
                hotLineTime: "（工作日上午8:30-11:30，下午13:00-17:30）",
                wx: "lvdidajiacai",
                email: "hezhi@greenlandhk.com"
            }
        }
        // 拷贝方法，tip: 不适用 File 类型拷贝
        Vue.prototype.$clone = function (val) {
            try {
                return JSON.parse(JSON.stringify(val));
            } catch (e) {
                throw new Error('clone error')
            }
        }
        /**
         * 下载文件
         * @param {*} array
         * @param name 文件名
         * @param url 文件地址
         */
         Vue.prototype.$download = function (array = [], loadingStartCb, loadingEndCb) {
            typeof loadingStartCb === 'function' && loadingStartCb()
            return new Promise((resolve, reject) => {
                const promiseList = [];
                array.forEach(file => {
                    let promise = new Promise((resolve) => {
                        const x = new XMLHttpRequest();
                        x.open("GET", file.url, true);
                        x.setRequestHeader('If-Modified-Since', '0');
                        x.responseType = "blob";
                        x.onload = e => {
                            download(x.response, file.name, x.response.type);
                            resolve();
                        };
                        x.send();
                    })
                    promiseList.push(promise);
                });
                Promise.all(promiseList).then(() => {
                    typeof loadingEndCb === 'function' && loadingEndCb()
                    resolve();
                })
            })
        };
    }
}




// WEBPACK FOOTER //
// ./src/utils/util.js